export const tr = (item, lang, def = '') =>
  ((typeof item === 'string') ? item : item.get(lang, item.get('fr', def)));

export const trIn = (item, key, lang, def = '') =>
  item.getIn([key, lang], item.getIn([key, 'fr'], item.get(key, def)));

export const trUri = (item, lang, def = '') => trIn(item, 'uri', lang, def);

export const findImagesPosition = (item) => item.flatten(3).get('position', 'top');

export const isCarousel = (item) => item.flatten(3).get('carrousel', false);

export const findPrevNextFromUri = (items, uri, lang, loop = false) => {
  const c = items.findKey(item => trUri(item, lang) === uri);
  const current = (typeof c === 'undefined') ? -1 : c;
  if (loop) {
    const slice = items.concat(items).skip((current === 0) ? items.size - 1 : current - 1);
    return [slice.first(), slice.rest().rest().first()];
  }
  const slice = (current > 1) ? items.skip(current - 1) : items;
  if (current === -1) {
    return [undefined, slice.first()];
  }
  if (current === 0) {
    return [undefined, slice.rest().first()];
  }
  if (slice.size > 2) {
    return [slice.first(), slice.rest().rest().first()];
  }
  return [slice.first()];
};



// WEBPACK FOOTER //
// ./common/utils.js